import { Link } from 'react-router-dom';
import { useState } from 'react';
import { Menu, X, Home, Users, Calendar, Handshake, MessageSquare, UserPlus } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { path: '/', label: 'Home', icon: <Home className="w-4 h-4" /> },
    { path: '/mentors', label: 'Mentors', icon: <Users className="w-4 h-4" /> },
    { path: '/workshops', label: 'Workshops', icon: <Calendar className="w-4 h-4" /> },
    { path: '/collaborations', label: 'Collaborations', icon: <Handshake className="w-4 h-4" /> },
    { path: '/community', label: 'Community', icon: <MessageSquare className="w-4 h-4" /> },
    { path: '/team', label: 'Team', icon: <UserPlus className="w-4 h-4" /> },
  ];

  return (
    <nav className="bg-[#005461] text-white sticky top-0 z-50 shadow-sm">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          
          {/* Logo - Circular Design with Object-Cover */}
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="relative w-9 h-9">
              {/* Optional: White background for better contrast */}
              <div className="absolute inset-0 bg-white rounded-full"></div>
              {/* Logo with object-cover for cropping */}
              <div className="absolute inset-0 rounded-full overflow-hidden">
                <img 
                  src="/logo.png" 
                  alt="GrowOn Logo" 
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = `
                      <div class="w-full h-full bg-[#0C7779] rounded-full flex items-center justify-center">
                        <span class="font-bold text-white text-sm">G</span>
                      </div>
                    `;
                  }}
                />
              </div>
            </div>
            <div className="text-left">
              <h1 className="text-lg font-bold text-white">GrowOn</h1>
              <p className="text-xs text-white/70">Community</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="flex items-center space-x-2 px-4 py-2 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-colors duration-200 text-sm font-medium"
              >
                <span>{link.icon}</span>
                <span>{link.label}</span>
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-white hover:bg-white/10 rounded-lg transition-colors"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden mt-3 border-t border-white/10 pt-3">
            <div className="flex flex-col space-y-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="flex items-center space-x-3 px-4 py-3 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-colors text-sm font-medium"
                  onClick={() => setIsOpen(false)}
                >
                  <span>{link.icon}</span>
                  <span>{link.label}</span>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;